import { render, staticRenderFns } from "./SelectorRevision.vue?vue&type=template&id=351e0938"
import script from "./SelectorRevision.vue?vue&type=script&lang=js"
export * from "./SelectorRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports